/* Modalco · içerik duyarlı görsel sığdırma (v2 · performans)
   Banner/kart görsellerinde ürünlerin kırpılmasını önler.
   v2: ölçüm sonuçları tarayıcıda önbelleğe alınır (aynı görsel bir daha analiz edilmez),
   görseller ekrana yaklaşınca ve tarayıcı boştayken işlenir,
   tüm ölçümler önce okunur sonra yazılır (zorunlu yeniden yerleşim yok). */
(function () {
  var SEL = '.mc-strip__img img,.mc-pcard__img img,.mc-split__img img,.mc-edit img,.mc-promo__img img,.mc-hero__tile img';
  /* Açılış popup görseli (.mc-pop__img) 2026-10-13'te listeden çıkarıldı: görsel popup çerçevesine göre (mobil şerit + masaüstü panel) tasarlandı, temadaki object-fit:cover ile gösterilir. Geri alma: listeye '.mc-pop__img img' eklenir. */
  var BOTTOM = '.mc-edit';
  var MS = [0.045, 0.02, 0.005];
  var CW = 160; // analiz tuvali genişliği
  var LSK = 'mcfit2';
  var store = {};
  try { store = JSON.parse(localStorage.getItem(LSK) || '{}') || {}; } catch (e) { store = {}; }
  var dirty = 0, saveT;
  function key(img) {
    var u = img.currentSrc || img.src || '';
    var q = u.indexOf('?'), base = q > -1 ? u.slice(0, q) : u, v = '';
    if (q > -1) { var m = u.slice(q).match(/[?&]v=(\d+)/); if (m) v = m[1]; }
    return base.replace(/^https?:\/\/[^/]+/, '').replace(/_\d+x\d*(?=\.)/, '') + '|' + v;
  }
  function persist() {
    if (!dirty) return; dirty = 0;
    try {
      var ks = Object.keys(store);
      if (ks.length > 160) ks.slice(0, ks.length - 160).forEach(function (k) { delete store[k]; });
      localStorage.setItem(LSK, JSON.stringify(store));
    } catch (e) {}
  }
  function analyse(img) {
    if (img._mcA !== undefined) return img._mcA;
    var k = key(img);
    if (store[k] !== undefined) return (img._mcA = store[k]);
    var a = null;
    try {
      var w = CW, h = Math.max(24, Math.round(CW * img.naturalHeight / img.naturalWidth));
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(img, 0, 0, w, h);
      var d = x.getImageData(0, 0, w, h).data;
      var px = function (i, j) { var o = (j * w + i) * 4; return [d[o], d[o + 1], d[o + 2]]; };
      var cs = [px(1, 1), px(w - 2, 1), px(1, h - 2), px(w - 2, h - 2), px(w >> 1, 1), px(w >> 1, h - 2)];
      var bg = [0, 1, 2].map(function (ch) { var v = cs.map(function (p) { return p[ch]; }).sort(function (p, q) { return p - q; }); return Math.round((v[2] + v[3]) / 2); });
      var bmx = Math.max(bg[0], bg[1], bg[2]), bmn = Math.min(bg[0], bg[1], bg[2]);
      var cols = new Array(w).fill(0), rows = new Array(h).fill(0);
      for (var j = 0; j < h; j++) for (var i = 0; i < w; i++) {
        var o = (j * w + i) * 4, r = d[o], g = d[o + 1], b = d[o + 2];
        var diff = Math.abs(r - bg[0]) + Math.abs(g - bg[1]) + Math.abs(b - bg[2]);
        if (diff <= 40) continue;
        var mx = Math.max(r, g, b), mn = Math.min(r, g, b), sat = Math.abs(mx - mn - (bmx - bmn));
        if (diff > 90 || (diff > 55 && sat > 35) || (mn > 238 && bmn < 228) || (mx < 90 && diff > 60)) { cols[i]++; rows[j]++; }
      }
      var lim = function (arr, n) { var t = Math.max(2, Math.round(n * 0.03)), s = 0, e = arr.length - 1; while (s < arr.length && arr[s] < t) s++; while (e > s && arr[e] < t) e--; return [s / arr.length, (e + 1) / arr.length]; };
      var bx = lim(cols, h), by = lim(rows, w);
      var strip = function (isCol, at) {
        var n = 9, L = isCol ? h : w, stops = [];
        for (var s = 0; s < n; s++) {
          var t = s / (n - 1), acc = [0, 0, 0], cnt = 0;
          for (var dd = -1; dd <= 1; dd++) { var al = Math.min(L - 1, Math.max(0, Math.round(t * (L - 1)) + dd)), v = isCol ? px(at, al) : px(al, at); acc[0] += v[0]; acc[1] += v[1]; acc[2] += v[2]; cnt++; }
          stops.push('rgb(' + acc.map(function (q) { return Math.round(q / cnt); }).join(',') + ') ' + (t * 100).toFixed(0) + '%');
        }
        return stops.join(',');
      };
      a = { top: strip(false, 0), bot: strip(false, h - 1), left: strip(true, 0), right: strip(true, w - 1), x0: bx[0], x1: bx[1], y0: by[0], y1: by[1] };
      if (bx[1] <= bx[0] || by[1] <= by[0]) { a.x0 = a.y0 = 0; a.x1 = a.y1 = 1; }
      a.photo = (a.x1 - a.x0 > 0.92 && a.y1 - a.y0 > 0.92) ? 1 : 0;
      store[k] = a; dirty = 1; clearTimeout(saveT); saveT = setTimeout(persist, 800);
    } catch (e) { a = null; }
    img._mcA = a; return a;
  }
  /* hesap: yalnızca okur, uygulanacak stilleri döndürür */
  function plan(img, box) {
    if (box.width < 20 || box.height < 20) return null;
    var nr = img.naturalWidth / img.naturalHeight, br = box.width / box.height, bottom = !!img.closest(BOTTOM);
    if (Math.abs(br / nr - 1) < 0.02) return { fit: 'cover', pos: '50% 50%', bg: '', par: 0 };
    var a = analyse(img);
    if (!a) return { fit: 'contain', pos: bottom ? '50% 100%' : '50% 50%', bg: null, par: null };
    if (a.photo) return { fit: 'cover', pos: '50% 30%', bg: null, par: null };
    var wide = br > nr, f = wide ? nr / br : br / nr, lo, hi, ok = false;
    for (var mi = 0; mi < MS.length && !ok; mi++) { lo = Math.max(0, (wide ? a.y0 : a.x0) - MS[mi]); hi = Math.min(1, (wide ? a.y1 : a.x1) + MS[mi]); ok = hi - lo <= f; }
    if (ok) {
      var c = (lo + hi) / 2, off = Math.min(Math.max(c - f / 2, 0), 1 - f);
      if (bottom && wide) off = Math.min(Math.max(hi - f, 0), 1 - f);
      var pct = (1 - f) > 0 ? off / (1 - f) * 100 : 50;
      return { fit: 'cover', pos: wide ? '50% ' + pct.toFixed(1) + '%' : pct.toFixed(1) + '% 50%', bg: '', par: 0 };
    }
    var fill = wide
      ? 'linear-gradient(to bottom,' + a.left + ') left/50.5% 100% no-repeat,linear-gradient(to bottom,' + a.right + ') right/50.5% 100% no-repeat'
      : (bottom ? 'linear-gradient(to right,' + a.top + ') top/100% 100% no-repeat'
        : 'linear-gradient(to right,' + a.top + ') top/100% 50.5% no-repeat,linear-gradient(to right,' + a.bot + ') bottom/100% 50.5% no-repeat');
    return { fit: 'contain', pos: bottom ? '50% 100%' : '50% 50%', bg: fill, par: 1 };
  }
  function apply(img, p) {
    var s = img.style, par = img.parentElement;
    s.objectFit = p.fit; s.objectPosition = p.pos;
    if (p.bg !== null) s.background = p.bg;
    if (p.par === 1 && par) { par.style.background = p.bg; par._mcBg = 1; }
    else if (p.par === 0 && par && par._mcBg) { par.style.background = ''; par._mcBg = 0; }
  }
  /* toplu işlem: önce tüm ölçümler, sonra tüm yazımlar */
  function batch(list) {
    var ready = list.filter(function (img) { return img.isConnected && img.complete && img.naturalWidth; });
    var boxes = ready.map(function (img) { return img.getBoundingClientRect(); });
    var plans = ready.map(function (img, i) { return plan(img, boxes[i]); });
    ready.forEach(function (img, i) { if (plans[i]) { apply(img, plans[i]); img._mcDone = 1; } });
  }
  var queue = [], qT = 0;
  var idle = window.requestIdleCallback || function (cb) { return setTimeout(function () { cb({ timeRemaining: function () { return 8; } }); }, 1); };
  function flush(dl) {
    qT = 0;
    var take = [];
    while (queue.length && (take.length < 2 || (dl && dl.timeRemaining() > 6))) take.push(queue.shift());
    batch(take);
    if (queue.length) qT = idle(flush, { timeout: 600 });
  }
  function enqueue(img, urgent) {
    if (queue.indexOf(img) < 0) queue.push(img);
    if (urgent && !qT) { flush(null); return; }
    if (!qT) qT = idle(flush, { timeout: 600 });
  }
  function hook(img, urgent) {
    if (img.complete && img.naturalWidth) enqueue(img, urgent);
    else if (!img._mcL) { img._mcL = 1; img.addEventListener('load', function () { enqueue(img, true); }, { once: true }); }
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); hook(e.target, true); } });
  }, { rootMargin: '400px 0px' }) : null;
  function scan() {
    document.querySelectorAll(SEL).forEach(function (img) {
      if (img._mcSeen) return; img._mcSeen = 1;
      if (io) io.observe(img); else hook(img, false);
    });
  }
  /* yeniden boyutlandırma / açılır pencere: işlenmiş görselleri yeniden hesapla */
  function rerun(scope) {
    var list = [].slice.call((scope || document).querySelectorAll(SEL));
    if (scope && scope.matches && scope.matches(SEL)) list.push(scope);
    list.forEach(function (img) { if (img._mcDone || !io) hook(img, false); });
    scan();
  }
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { rerun(); }, 200); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  /* görünür alanda olmayanlar (kaydırmalı alanlar vb.) tarayıcı boştayken işlenir */
  function background() { document.querySelectorAll(SEL).forEach(function (img) { if (!img._mcDone) hook(img, false); }); }
  window.addEventListener('load', function () { scan(); idle(background, { timeout: 2500 }); setTimeout(persist, 3000); });
  window.addEventListener('pagehide', persist);
  if ('MutationObserver' in window) {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var t = ms[i].target;
        if (t.matches && t.matches('.mc-pop,.mc-pop *')) {
          var pop = t.closest('.mc-pop');
          var go = function () { [].slice.call(pop.querySelectorAll(SEL)).forEach(function (img) { img._mcSeen = 1; hook(img, true); }); };
          setTimeout(go, 60); setTimeout(go, 450); setTimeout(go, 1200);
          break;
        }
      }
    }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['hidden', 'class'] });
  }
  window.mcFit = function () { rerun(); };
})();
